/* eslint-disable */
import { useState, useEffect, forwardRef } from "react";
import "./style.css";
import {
  getDtcInData,
  getDtcOutData,
  getDtcSummaryData,
  isServiceHealthy,
} from "../../utils/API";
import withUser from "../../redux/HOC/withUser";
import {
  constants,
  EndPoint,
  messages,
  socketMsgType,
} from "../../common/constants";
import moment from "moment";
import RefreshIcon from "@mui/icons-material/Refresh";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import SearchIcon from "@mui/icons-material/Search";
import { Subject } from "rxjs";
import { ActivationState, Stomp } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import _ from "lodash";
import {
  debounceGlobalSearch,
  getTimeStamp,
  mapRowId,
} from "../../common/commonFunctions";
import {
  BASE_URI_SOCKET,
  envs,
  getEnv,
  serviceAPIMapping,
} from "../../config/service-api-mapping";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import excel from "../../assets/images/excel.svg";
import ContractActivityGrid from "./ContractActivity";
import DtcActivityGrid from "./DtcActivity";
import SummaryGrid from "./Summary";
import { useNavigate } from "react-router";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { Split } from "@geoffcox/react-splitter";

const DTCDashboard = (props: any) => {
  //const contractSocket = new SockJS(`${BASE_URI_CONTRACT_T4_SOCKET()}`);
  //const dtcSocket = new SockJS(`${BASE_URI_DTC_SOCKET()}`);
  const consolidateSocket = new SockJS(`${BASE_URI_SOCKET()}`);
  // const contract18Socket = new SockJS(`${BASE_URI_CONTRACT18_SOCKET()}`);
  const [globalSearch, setGlobalSearch] = useState<string>("");
  const inGridDefaultFilter = {
    msg_type: { type: "set", values: ["DO", "RAD", "DROP_DO"] },
    // dtc_loanet_status: { type: "set", values: ["Non-Match"] },
  };
  const outGridDefaultFilter = {
    loanet_txn_description: {
      type: "set",
      values: [
        "Opened",
        "Partial",
        "Closed",
        "Rev Close",
        "Rev Partial",
        "Delete",
        "Update",
      ],
    },
  };
  const [isDataRefresh, setIsDataRefresh] = useState(false);
  const socketStompClient = Stomp.over(function () {
    return consolidateSocket;
  });
  // const dtcStompClient = Stomp.over((function () {
  //   return dtcSocket
  // }));
  // const contractStompClient = Stomp.over((function () {
  //   return contractSocket
  // }));
  // const contract18StompClient = Stomp.over((function () {
  //   return contract18Socket
  // }));
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [screenHeight, setScreenHeight] = useState(
    window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
  );
  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  // const subscribeContractEvents = () => {
  //   contractStompClient.subscribe(
  //     "/topic/t4_contracts_activity",
  //     function (result: any) {
  //       let resultJson = JSON.parse(result?.body);
  //       console.log("Data received from /topic/t4_contracts_activity: ", resultJson);
  //       upsertDTCContractActivity(resultJson);
  //     }
  //   );
  // };

  // const subscribeContract18Events = () => {
  //   contract18StompClient.subscribe(
  //     "/topic/18_contracts",
  //     function (result: any) {
  //       let resultJson = JSON.parse(result?.body);
  //       console.log("Data received from /topic/18_contracts: ", resultJson);
  //       upsertDTCContractActivity(resultJson);
  //     }
  //   );
  // };

  // let upsertSummary$ = new Subject<any>();
  // upsertSummary$.subscribe((trade: any) => {
  //   upsertSummary(trade);
  // });

  // const SubscribeDTCEvents = () => {
  //   dtcStompClient.subscribe("/topic/dtc_activity", function (result) {
  //     let resultJson = JSON.parse(result?.body);
  //     console.log("Data received from /topic/dtc_activity: ", resultJson);
  //     upsertDTCActivity(resultJson);
  //   });

  //   dtcStompClient.subscribe(
  //     "/topic/dtc_intraday_summary",
  //     function (result: any) {
  //       let resultJson = JSON.parse(result?.body);
  //       console.log(
  //         "Data received from /topic/dtc_intraday_summary: ",
  //         resultJson
  //       );
  //       upsertSummary(resultJson);
  //     }
  //   );

  //   dtcStompClient.subscribe(
  //     "/topic/dtc_match_loanet_status",
  //     function (result: any) {
  //       let resultJson = JSON.parse(result?.body);
  //       console.log(
  //         "Data received from /topic/dtc_match_loanet_status: ",
  //         resultJson
  //       );
  //       updateDTCStatusContractActGrid(resultJson);
  //     }
  //   );
  // };

  // function establishConnection() {
  //   // dtcStompClient.connect(
  //   //   {},
  //   //   function (frame: any) {
  //   //     SubscribeDTCEvents();
  //   //   },
  //   //   {},
  //   //   () => { }
  //   // );
  //   // contractStompClient.connect(
  //   //   {},
  //   //   function (frame: any) {
  //   //     subscribeContractEvents();
  //   //   },
  //   //   {},
  //   //   () => { }
  //   // );
  //   // contract18StompClient.connect(
  //   //   {},
  //   //   function (frame: any) {
  //   //     subscribeContract18Events();
  //   //   },
  //   //   {},
  //   //   () => { }
  //   // );
  // }

  // let upsertDTCSubscription: any;
  // let upsertIntradayDTCSubscription: any;
  // let upsertActivityDTCSubscription: any;

  // const compareBoxSegValues = (oldValue: any, newValue: any) => {
  //   if (newValue > oldValue) return BoxComparisonValueEnum.Increased;
  //   else if (newValue < oldValue) return BoxComparisonValueEnum.Decreased;
  //   else return BoxComparisonValueEnum.Unchanged;
  // };
  const [heightAG_1] = useState(35);
  const navigate = useNavigate();
  const [dtcActivityGridRef, setDtcActivityGridRef] = useState<any>(null);
  const [contractActGridRef, setContractActGridRef] = useState<any>(null);
  const [refDataSummary, setRefDataSummary] = useState<any>(null);
  const [gridApi, setGridApi] = useState<any>(null);

  const [dtcSummaryList, setDtcSummaryList] = useState<any[]>([]);
  const [dtcActivityList, setDtcActivityList] = useState<any[]>([]);
  const [contractActivityList, setContractActivityList] = useState<any[]>([]);

  const [lastRefresh, setLastRefresh] = useState<any>("");
  const [showScreenLoader, setShowScreenLoader] = useState<boolean>(false);
  const [insertDtcActivityRow, setInsertDtcActivityRow] = useState<any>([]);
  const [insertContractActRow, setInsertContractActRow] = useState<any>(null);
  const [insertContractActRowIds, setInsertContractActRowIds] =
    useState<any>(null);
  const [insertDtcActRowIds, setInsertDtcActRowIds] = useState<any>(null);
  const [insertSummaryRowIds, setInsertSummaryRowIds] = useState<any>(null);
  const [insertSummaryRow, setInsertSummaryRow] = useState<any>(null);

  const createConnection = () => {
    // if (dtcStompClient.state !== ActivationState.ACTIVE) {
    //   establishConnection();
    // }
    // if (contractStompClient.state !== ActivationState.ACTIVE) {
    //   establishConnection();
    // }
    // if (contract18StompClient.state !== ActivationState.ACTIVE) {
    //   establishConnection();
    // }

    socketStompClient.connect(
      {},
      function (frame: any) {
        socketStompClient.subscribe(
          "/topic/consolidated_message",
          function (result: any) {
            let resultJson = JSON.parse(result?.body);
             if(getEnv() !== envs.PROD){
                console.log(`Data received from /topic/consolidated_message at ${moment()?.toDate()} - `, resultJson);
             }
            
            onDTCSocketReceive(resultJson?.socketMssgmap);
          }
        );
      },
      {},
      () => {}
    );
  };

  const onDTCSocketReceive = async (msg: any) => {
    try {
      const contractList = _.get(msg, socketMsgType.CONTRACT_ACTIVITY);
      const dtcActivityList = _.get(msg, socketMsgType.DTC_ACTIVITY);
      const dtcIntradaySummaryList = _.get(
        msg,
        socketMsgType.DTC_INTRADAY_SUMMARY
      );
      const dtsStatusUpdateList = _.get(
        msg,
        socketMsgType.MATCH_CONTRACT_ACTIVITY
      );

      if (_.isArray(dtcActivityList) && !_.isEmpty(dtcActivityList)) {
        let socketRows = [...dtcActivityList]?.map((item: any) => {
          return item?.messageJson;
        });
        upsertDTCActivity(socketRows);
      }
      if (_.isArray(contractList) && !_.isEmpty(contractList)) {
        let socketRows = [...contractList]?.map((item: any) => {
          return item?.messageJson;
        });
        const filteredRows = socketRows?.filter(
          (c: any) =>
            c?.activity_id && c?.activity_id > 0 && c?.ui_status !== "Failed"
        );
        if (
          filteredRows &&
          _.isArray(filteredRows) &&
          filteredRows?.length > 0
        ) {
          upsertDTCContractActivity(filteredRows);
        }
      }
      if (_.isArray(dtsStatusUpdateList) && !_.isEmpty(dtsStatusUpdateList)) {
        let socketRows = [...dtsStatusUpdateList]?.map((item: any) => {
          return item?.messageJson;
        });
        updateDTCStatusContractActGrid(socketRows);
      }

      if (
        _.isArray(dtcIntradaySummaryList) &&
        !_.isEmpty(dtcIntradaySummaryList)
      ) {
        let socketRows = [...dtcIntradaySummaryList]?.map((item: any) => {
          return item?.messageJson;
        });
        upsertSummary(socketRows);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    createConnection();

    return () => {
      if (socketStompClient?.connected) {
        socketStompClient?.deactivate();
        socketStompClient?.unsubscribe("/topic/consolidated_message");
      }
    };
  }, []);

  const upsertDTCContractActivity = (socketRows: any) => {
    const rowsToInsert = _.differenceBy(
      [...socketRows],
      contractActivityList,
      "activity_id"
    );
    // const rowsToUpdate = _.intersectionBy(
    //   [...socketRows],
    //   contractActivityList,
    //   "ref_msgid"
    // );
    if (_.isArray(rowsToInsert) && rowsToInsert?.length > 0) {
      let rows = [...rowsToInsert]?.map((item: any) => {
        return { ...item, id: item?.activity_id?.toString() };
      });
      setInsertContractActRow(rows);
      // setContractActivityList((previousRows: any) => {
      //   return [rows, ...previousRows];
      // });
    }
  };

  useEffect(() => {
    if (insertContractActRow && insertContractActRow?.length > 0) {
      const rows = insertContractActRow?.map((row: any) => {
        return {
          ...row,
          activity_id: row.activity_id,
          id: row.activity_id,
          bl: row?.contract_type,
          cptyId: row?.cpty_id,
          contract_id_new: row?.contract_id,
          colvalue: row?.contract_value,
          sec_id: row?.cusip,
          smnt_date: row?.settle_date,
          updatedDate: new Date(row?.update_date),
          updatedDateStr: getTimeStamp(row?.update_date),
          createdDate: getTimeStamp(row?.create_date),
        };
      });

      // let dtcSumryJson: any = {
      //   ...insertContractActRow,
      //   activity_id: insertContractActRow.activity_id,
      //   id: insertContractActRow.activity_id,
      //   bl: insertContractActRow?.contract_type,
      //   cptyId: insertContractActRow?.cpty_id,
      //   contract_id_new: insertContractActRow?.contract_id,
      //   colvalue: insertContractActRow?.contract_value,
      //   sec_id: insertContractActRow?.cusip,
      //   smnt_date: insertContractActRow?.settle_date,
      //   updatedDate: new Date(insertContractActRow?.update_date),
      //   updatedDateStr: getTimeStamp(insertContractActRow?.update_date),
      //   createdDate: getTimeStamp(insertContractActRow?.create_date),
      // };

      const ids = rows?.map((c: any) => {
        return c?.id;
      });
      setInsertContractActRowIds(ids?.length > 0 ? [ids] : []);
      if (rows && _.isArray(rows) && rows?.length > 0) {
        setContractActivityList((previousRows: any) => {
          const mergedRows = [...rows, ...previousRows];
          const uniqueRows = _.uniqBy(mergedRows, "activity_id");

          return uniqueRows;
        });
      }

      // setContractActivityList((previousRows: any) => {
      //   if (_.isArray(previousRows)) {
      //     return [dtcSumryJson, ...previousRows];
      //   }
      //   return previousRows;
      // });
    }
  }, [insertContractActRow]);

  const upsertSummary = (trades: any) => {
    setDtcSummaryList((previousRows: any) => {
      // if (_.isArray(previousRows)) {
      let currentRows = [...previousRows];
      const insertRows = _.differenceBy([...trades], [...previousRows], "id");
      const updateRows = _.intersectionBy([...trades], [...previousRows], "id");

      if (insertRows && _.isArray(insertRows) && !_.isEmpty(insertRows)) {
        setInsertSummaryRow(_.uniqBy(insertRows, "id"));
      }

      const deleteIndexList: any[] = [];
      updateRows?.forEach((trade) => {
        let index = currentRows?.findIndex((t: any) => t.id === trade?.id);
        if (index >= 0 && (trade?.box_qty > 0 || trade?.seg_qty > 0)) {
          currentRows[index].box_qty =
            trade?.box_qty && trade?.box_qty >= 0
              ? parseInt(trade?.box_qty)
              : trade?.box_qty;
          currentRows[index].seg_qty =
            trade?.seg_qty && trade?.seg_qty >= 0
              ? parseInt(trade?.seg_qty)
              : trade?.seg_qty;
          currentRows[index].col_value =
            trade?.col_value && trade?.col_value >= 0
              ? parseInt(trade?.col_value)
              : trade?.col_value;
          currentRows[index].updatedDateStr = getTimeStamp(trade?.update_date);
          (currentRows[index].updatedDate = new Date(trade?.update_date)),
            (currentRows[index].updated_by = trade?.updated_by);
        } else if (
          index >= 0 &&
          (((_.isUndefined(trade?.box_qty) || _.isNull(trade?.box_qty)) &&
            (_.isUndefined(trade?.seg_qty) || _.isNull(trade?.seg_qty))) ||
            (trade?.box_qty == 0 && trade?.seg_qty == 0))
        ) {
          // let filteredRows = _.filter(currentRows, function (o, ind) {
          //   return ind !== index;
          // });
          // return filteredRows;
          deleteIndexList?.push(index);
        }
        // else {
        //   if (trade?.box_qty > 0 || trade?.seg_qty > 0) {
        //     setInsertSummaryRow(trade);
        //   }
        // }
      });
      if (deleteIndexList?.length > 0) {
        const filteredList = currentRows?.filter(
          (c, ind) => !_.includes(deleteIndexList, ind)
        );
        currentRows = filteredList;
      }

      return _.uniqBy(currentRows, "id");

      //}
      //return previousRows;
    });
  };

  useEffect(() => {
    if (
      insertSummaryRow &&
      _.isArray(insertSummaryRow) &&
      insertSummaryRow?.length > 0
    ) {
      const rows = insertSummaryRow?.map((row) => {
        return {
          ...row,
          id: row?.id,
          box_qty:
            row?.box_qty && row?.box_qty >= 0
              ? parseInt(row?.box_qty)
              : row?.box_qty,
          seg_qty:
            row?.seg_qty && row?.seg_qty >= 0
              ? parseInt(row?.seg_qty)
              : row?.seg_qty,
          updatedDateStr: getTimeStamp(row?.update_date),
          updatedDate: new Date(row?.update_date),
          col_value:
            row?.col_value && row?.col_value >= 0
              ? parseInt(row?.col_value)
              : row?.col_value,
          createdDate: getTimeStamp(row?.create_date),
        };
      });

      if (rows && _.isArray(rows) && rows?.length > 0) {
        setDtcSummaryList((previousRows: any) => {
          const mergedRows = [...rows, ...previousRows];
          const unique = _.uniqBy(mergedRows, "id");

          return unique;
        });

        const ids = rows?.map((c: any) => {
          return c?.id;
        });
        setInsertSummaryRowIds(ids?.length > 0 ? [ids] : []);
      }
    }
  }, [insertSummaryRow]);

  const updateDTCStatusContractActGrid = (trades: any) => {
    setContractActivityList((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.id === trade?.activity_id.toString()
            );
            if (index >= 0) {
              currentRows[index].dtc_status = trade?.dtc_status;
            }
          });
          return currentRows;
        }
      }

      return previousRows;
    });
  };

  function onExcelExport() {
    var spreadsheets = [];

    spreadsheets.push(
      contractActGridRef?.current?.api?.getSheetDataForExcel?.({
        sheetName: "Contract Activity",
      })!,
      dtcActivityGridRef?.current?.api?.getSheetDataForExcel?.({
        sheetName: "DTC Activity",
      })!,
      refDataSummary?.current?.api?.getSheetDataForExcel?.({
        sheetName: "Summary",
      })!
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "dtc-dashboard.xlsx",
    });
  }

  useEffect(() => {
    resfreshDate();
  }, [dtcActivityList, contractActivityList, dtcSummaryList]);

  useEffect(() => {
    if (_.isArray(insertDtcActivityRow) && insertDtcActivityRow?.length > 0) {
      const rows = insertDtcActivityRow?.map((row: any) => {
        return {
          ...row,
          id: row?.ref_msgid?.toString(),
          account_id: row?.client,
          quantity:
            row?.quantity && !_.isEmpty(row?.quantity)
              ? parseInt(row?.quantity)
              : row?.quantity,
          reason_desc: row?.reason_descrition,
          createdDate: getTimeStamp(row?.create_date),
          updatedDate: new Date(row?.update_date),
          updatedDateStr: getTimeStamp(row?.update_date),
        };
      });
      if (rows && _.isArray(rows) && rows?.length > 0) {
        setDtcActivityList((previousRows: any) => {
          const mergedRows = [...rows, ...previousRows];
          const uniqueRows = _.uniqBy(mergedRows, "ref_msgid");

          return uniqueRows;
        });
        const ids = rows?.map((c: any) => {
          return c?.id;
        });
        setInsertDtcActRowIds(ids?.length > 0 ? [ids] : []);
      }
    }
  }, [insertDtcActivityRow]);

  const upsertDTCActivity = (trades: any[]) => {
    setDtcActivityList((previousRows: any) => {
      let currentRows = [...previousRows];
      const insertRows: any[] = _.differenceBy(
        trades,
        currentRows,
        "ref_msgid"
      );
      if (insertRows?.length > 0) {
        setInsertDtcActivityRow(insertRows);
      }

      const updateRows = _.intersectionBy(trades, currentRows, "ref_msgid");

      updateRows?.forEach((row) => {
        const index = currentRows?.findIndex(
          (c: any) => c.ref_msgid === row?.ref_msgid
        );

        if (index >= 0) {
          currentRows[index].dtc_loanet_status = row?.dtc_loanet_status;
          currentRows[index].loanet_contract = row?.loanet_contract;
        }
      });

      return currentRows;
    });

    // trades?.forEach((trade:any)=>{
    //   trade.id = trade?.ref_msgid?.toString(),
    //   trade.updatedDate = getTimeStamp(trade.update_date),
    //   setDtcActivityList((previousRows: any) => {
    //     let currentRows = [...previousRows];
    //     const insertRows:any[] =  _.differenceBy(
    //       trades,
    //       previousRows,
    //       "contract_id"
    //     );

    //     let index = currentRows?.findIndex(t => t.id === trade?.id);
    //     if (index >= 0) {
    //       currentRows[index].dtc_loanet_status = trade?.dtc_loanet_status;
    //       currentRows[index].loanet_contract = trade?.loanet_contract;
    //       return currentRows;
    //     }
    //     else {
    //       setInsertDtcActivityRow(trade);
    //     }
    //     return previousRows;
    //   });
    // })
  };

  const loadDtcSummary = async (accId: any) => {
    setDtcSummaryList([]);
    let dtcSummaryRes: any = "";
    let accessToken = window.localStorage.getItem("refreshtoken");
    let dtcSumryData: any = [];
    try {
      dtcSummaryRes = await getDtcSummaryData(
        accId,
        props.user.tokenType,
        accessToken
      );
      if (!dtcSummaryRes) {
        setOpen(true);
        setSnackbarMessage(messages.dtcServiceDown);
      } else if (dtcSummaryRes?.status === 200) {
        const dtcApi = await dtcSummaryRes.json();
        let dtcApiResult = dtcApi?.result;
        if (dtcApiResult?.length > 0) {
          dtcApiResult?.map((dtcSummary: any, index: any) => {
            let dtcSumryJson = {
              ...dtcSummary,
              id: dtcSummary?.id,
              box_qty:
                dtcSummary?.box_qty && dtcSummary?.box_qty >= 0
                  ? parseInt(dtcSummary?.box_qty)
                  : dtcSummary?.box_qty,
              seg_qty:
                dtcSummary?.seg_qty && dtcSummary?.seg_qty >= 0
                  ? parseInt(dtcSummary?.seg_qty)
                  : dtcSummary?.seg_qty,
              updatedDateStr: getTimeStamp(dtcSummary?.update_date),
              updatedDate: new Date(dtcSummary?.update_date),
              col_value:
                dtcSummary?.col_value && dtcSummary?.col_value >= 0
                  ? parseInt(dtcSummary?.col_value)
                  : dtcSummary?.col_value,
              createdDate: getTimeStamp(dtcSummary?.create_date),
            };
            dtcSumryData.push(dtcSumryJson);
          });
          let sortedRows = _.orderBy(dtcSumryData, ["updatedDate"], ["desc"]);
          setDtcSummaryList(sortedRows);
        } else {
          setDtcSummaryList([]);
        }
      } else if (dtcSummaryRes.status === 401) {
        navigate("/signin");
      } else {
        setDtcSummaryList([]);
      }
    } catch (err) {
      setDtcSummaryList([]);
    }
  };

  const loadDtcInSummary = async (accId: any) => {
    setDtcActivityList([]);
    let dtcInRes: any = "";
    let accessToken = window.localStorage.getItem("refreshtoken");
    let dtcInData: any = [];
    try {
      dtcInRes = await getDtcInData(accId, props.user.tokenType, accessToken);
      if (!dtcInRes) {
        setOpen(true);
        setSnackbarMessage(messages.dtcServiceDown);
      } else if (dtcInRes?.status === 200) {
        const dtcApi = await dtcInRes.json();
        let dtcApiResult = dtcApi?.result;
        if (dtcApiResult?.length > 0) {
          dtcApiResult?.map((dtcSummary: any, index: any) => {
            let dtcSumryJson = {
              ...dtcSummary,
              id: dtcSummary?.ref_msgid?.toString(),
              account_id: dtcSummary?.account_id,
              quantity:
                dtcSummary?.quantity && !_.isEmpty(dtcSummary?.quantity)
                  ? parseInt(dtcSummary?.quantity)
                  : dtcSummary?.quantity,
              reason_desc: dtcSummary?.reason_desc,
              createdDate: getTimeStamp(dtcSummary?.create_date),
              updatedDate: new Date(dtcSummary?.update_date),
              updatedDateStr: getTimeStamp(dtcSummary?.update_date),
            };
            dtcInData.push(dtcSumryJson);
          });
          let sortedRows = _.orderBy(dtcInData, ["updatedDate"], ["desc"]);
          setDtcActivityList(sortedRows);
        } else {
          setDtcActivityList([]);
        }
      } else if (dtcInRes.status === 401) {
        navigate("/signin");
      } else {
        setDtcActivityList([]);
      }
    } catch (err) {
      setDtcActivityList([]);
    }
  };

  const loadDtcOutSummary = async (accId: any) => {
    setContractActivityList([]);
    let dtcOutRes: any = "";
    let accessToken = window.localStorage.getItem("refreshtoken");
    let dtcOutData: any = [];
    try {
      dtcOutRes = await getDtcOutData(accId, props.user.tokenType, accessToken);
      if (!dtcOutRes) {
        setOpen(true);
        setSnackbarMessage(messages.dtcServiceDown);
      } else if (dtcOutRes?.status === 200) {
        const dtcApi = await dtcOutRes.json();
        let dtcApiResult = dtcApi?.result;
        if (dtcApiResult?.length > 0) {
          dtcApiResult?.map((r: any, i: any) => {
            let dtcSumryJson = {
              ...r,
              activity_id: r.activity_id,
              id: r.activity_id,
              bl: r?.bl,
              cptyId: r?.cpty_id,
              contract_id_new: r?.contract_id,
              colvalue: r?.colvalue,
              updatedDate: new Date(r?.update_date),
              updatedDateStr: getTimeStamp(r?.update_date),
              createdDate: getTimeStamp(r?.create_date),
            };
            dtcOutData.push(dtcSumryJson);
          });
          let sortedRows = _.orderBy(dtcOutData, ["updatedDate"], ["desc"]);
          setContractActivityList([...sortedRows]);
        } else {
          setContractActivityList([]);
        }
      } else if (dtcOutRes.status === 401) {
        navigate("/signin");
      } else {
        setContractActivityList([]);
      }
    } catch (err) {
      setContractActivityList([]);
    }
  };

  useEffect(() => {
    getServiceHealthCheck();
  }, []);

  const onPageLoadApiCall = () => {
    setShowScreenLoader(true);
    let accountId = window.localStorage.getItem("activeAccountCode");
    loadDtcSummary(accountId);
    loadDtcInSummary(accountId);
    loadDtcOutSummary(accountId);
    resfreshDate();
    setShowScreenLoader(false);
  };

  const getServiceHealthCheck = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["DTC-SETTLEMENT-PROCESSOR-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`${messages.dtcServiceDown}`);
        setOpen(true);
      } else {
        onPageLoadApiCall();
      }
    });
  };

  const refreshAccount = () => {
    let accountId = window.localStorage.getItem("activeAccountCode");
    setShowScreenLoader(true);
    setDtcSummaryList([]);
    setDtcActivityList([]);
    setContractActivityList([]);
    loadDtcSummary(accountId);
    loadDtcInSummary(accountId);
    loadDtcOutSummary(accountId);
    resfreshDate();
    setShowScreenLoader(false);
    setIsDataRefresh(!isDataRefresh);
  };

  const resfreshDate = () => {
    setLastRefresh(moment(new Date()).format(constants.RefreshFormat));
  };

  const onFilterTextChange = (event: any) => {
    debounceGlobalSearch(event.target.value, setGlobalSearch);
  };

  const getGridsHeight = () => {
    let offsetHeight = document?.getElementById("DTCTitleDiv")?.offsetHeight;
    return "calc(100% - " + (offsetHeight ? offsetHeight + 10 : 0) + "px)";
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <div
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "#EAECEF",
          overflow: "hidden",
        }}
        className="mx-auto"
      >
        {showScreenLoader && <SpinnerFullScreen></SpinnerFullScreen>}
        <div id="DTCTitleDiv" className="row w-100 mx-auto">
          <div className="col p-0 mx-auto w-100">
            <div className="row ms-1 title-subHeaderTitle dtc-title">
              DTC Dashboard
            </div>
            <div style={{ width: "100%" }} className="row p-0 my-1 mx-auto">
              <div className="col p-0 mx-auto w-100">
                <div className="globalfilterdiv globalSearch-globalFilter">
                  <input
                    type="search"
                    placeholder="Global search..."
                    id="filter-text-box"
                    onInput={onFilterTextChange}
                  />
                  <SearchIcon style={{ fontSize: "1rem", color: "#1e355e" }} />
                </div>
              </div>
              <div className="col p-0 mx-auto d-flex justify-content-end">
                <div
                  className="borrowExceldnld"
                  onClick={onExcelExport}
                  title="Download Excel"
                >
                  <img
                    src={excel}
                    alt=""
                    style={{
                      height: "1.8rem",
                      width: "1.8rem",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div
                  onClick={refreshAccount}
                  title="Refresh Data"
                  className="refresh-dtc"
                >
                  <RefreshIcon
                    style={{
                      color: "#1E355E",
                      marginRight: "0.5rem",
                      height: "1.6rem",
                      width: "1.6rem",
                      cursor: "pointer",
                    }}
                  />
                  <div className="refreshsettimedateContract">
                    <div>Last updated on: </div>
                    <div style={{ whiteSpace: "nowrap" }}>{lastRefresh}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="row mt-1 mx-auto"
          style={{ height: getGridsHeight(), width: "100%" }}
        >
          <Split minPrimarySize="65%">
            <div style={{ height: "100%" }}>
              <Split horizontal>
                <div style={{ height: "100%" }}>
                  <ContractActivityGrid
                    rowData={contractActivityList}
                    height={33.6}
                    title="Contract Activity"
                    globalSearch={globalSearch}
                    insertRowId={insertContractActRowIds}
                    type={constants.DtcOut}
                    getBtnRef={(gridRef: any) => {
                      setContractActGridRef(gridRef);
                    }}
                    getGridApi={(gridApi: any) => {
                      setGridApi(gridApi);
                    }}
                    defaultFilter={outGridDefaultFilter}
                    isDataRefresh={isDataRefresh}
                  />
                </div>
                <div style={{ height: "100%" }}>
                  <DtcActivityGrid
                    rowData={dtcActivityList}
                    height={33.6}
                    title="DTC Activity"
                    globalSearch={globalSearch}
                    insertRowId={insertDtcActRowIds}
                    type={constants.DtcOut}
                    getBtnRef={(gridRef: any) => {
                      setDtcActivityGridRef(gridRef);
                    }}
                    getGridApi={(gridApi: any) => {
                      setGridApi(gridApi);
                    }}
                    defaultFilter={inGridDefaultFilter}
                    isDataRefresh={isDataRefresh}
                  />
                </div>
              </Split>
            </div>
            <div style={{ height: "100%" }}>
              <SummaryGrid
                rowData={dtcSummaryList}
                title="Summary"
                globalSearch={globalSearch}
                insertRowId={insertSummaryRowIds}
                height={heightAG_1 * 2.1}
                type={constants.DtcSummary}
                getBtnRef={(gridRef: any) => {
                  setRefDataSummary(gridRef);
                }}
                getGridApi={(gridApi: any) => {
                  setGridApi(gridApi);
                }}
                isDataRefresh={isDataRefresh}
              />
            </div>
          </Split>
        </div>
      </div>
    </>
  );
};

export default withUser(DTCDashboard);
